<div class="banner" *ngIf="!expired">
  <quota-banner [hideTrialBanner]="true" [hideExpiredBanner]="true" [hideFeatureBanner]="true"></quota-banner>
</div>

<div class="container-fluid">
  <div class="flex flex-col items-start justify-between mid-tablet:flex-row mb-5 gap-3">
    <div class="flex items-center justify-start gap-3">
      <p class="text-2xl font-semibold !m-0">Employees</p>
      <mat-icon [class.spin]="isRefreshing" (click)="refreshEmployeeList()"
        class="cursor-pointer !text-[22px] !w-[22px] !h-[22px] relative top-[2px]" [disabled]="loading || isRefreshing"
        matTooltip="Refresh List">refresh</mat-icon>
    </div>
    <div class="w-full flex flex-col mid-tablet:w-max sm:flex-row items-center justify-end gap-3">
      <div class="rounded-lg transition-all duration-300 ease-out origin-right w-full lg:w-80 !h-[45px]">
        <app-employee-search [userList]="allUserList" [placeholder]="'Search Employee'" [isNeedUserReturn]="true"
          class="!w-full !h-full" [selectedEmployeeId]="''" (searchEmployeeName)="searchEmployee($event)" [isInputSearch]="true" [initialValue]="initialSearchValue">
        </app-employee-search>
      </div>
      <div class="w-full flex items-center justify-end mid-tablet:w-max gap-2">
        <span *ngIf="!expired" class="w-full mid-tablet:w-52"
          matTooltip="{{quota_remaining == 0 ? 'Upgrade your plan as there is no remaining user quota.' : ''}}">
          <button mat-stroked-button [disabled]="!isTourActive() || quota_remaining == 0"
            class="employee-import-btn !h-[45px] w-full !m-0" (click)="openImportUserModal(importModal)"
            [ngStyle]="{'visibility':(isAdmin && !isQuota) || !isTourActive() ? 'visible' : 'hidden','display':(isAdmin && !isQuota) || !isTourActive() ? 'block' : 'none'}">
            <span class="material-symbols-outlined">
              group_add
            </span>
            Import Employees
          </button>
        </span>
        <span *ngIf="!expired" class="w-full mid-tablet:w-52"
          [matTooltip]="!hasRemainingEmployeeQuota ? 'No seats left — upgrade to add employees.' : ''"
          [ngStyle]="{'visibility':(canManageEmployees && !isQuota) || !isTourActive() ? 'visible' : 'hidden','display':(canManageEmployees && !isQuota) || !isTourActive() ? 'block' : 'none'}">
          <button *ngIf="!hasRemainingEmployeeQuota" mat-raised-button
            class="employee-upgrade-btn !h-[45px] w-full !m-0" (click)="openPlanUpgradeModal()"
            id="createUserModalOpen" tourAnchor="addNewEmployee">
            <span class="material-symbols-outlined">upgrade</span>
            Upgrade Seats
          </button>
          <button *ngIf="hasRemainingEmployeeQuota" mat-raised-button [disabled]="!isTourActive()"
            class="employee-add-btn !h-[45px] w-full !m-0" (click)="openUserCreateModal()" id="createUserModalOpen"
            tourAnchor="addNewEmployee">
            <span class="material-symbols-outlined">
              person_add
            </span>
            New Employee
          </button>
        </span>
      </div>
    </div>
  </div>

  <div class="flex mb-5">
    <user-list-filter
      [employees]="allUserList"
      [statusEpoch]="statusEpoch"
      (statusChanges)="listenStatusFilterChange($event)"
      [queryFiltered]="queryFiltered">
    </user-list-filter>
  </div>

  <app-users-table [expired]="expired" [developerList]="developerList" [loadWaiter]="loading"
    (deleteEmployeee)="deleteEmployee()" (sortingData)="sortData($event)" [showAction]="true"
    [activeSort]="activeSort"></app-users-table>
  <mat-paginator [length]="paginatorLength" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOption"
    aria-label="Select page" (page)="onPaginateChange($event)" #EmpPaginator
    [ngStyle]="{'visibility':developerList && developerList.length ? 'visible' : 'hidden'}">
  </mat-paginator>
</div>

<div #importModal class="modal modal-import" style="width: 35vw !important;">
  <app-import-users></app-import-users>
</div>
